module.exports = __webpack_public_path__ + "static/13-Amlogic-586b3de5f679077e464c7aef3033b56b.png";